import React, { useState } from "react";
import AppModal from "../../../components/organisms/CustomModal";
import PageTitle from "../../../components/atoms/PageTitle";
import FormInput from "components/atoms/FormInput";
import verify_ticked from "../../../assets/svg/verify_ticked.svg";
import verify_unticked from "../../../assets/svg/verify_unticked.svg";
import showPwd from "../../../assets/svg/show.svg";
import hidePwd from "../../../assets/svg/hide.svg";
import Button from "components/atoms/Button";
import Alert from "components/atoms/Alert";
import { BASE_URL, loggedUser_baseURL, postRequest } from "services/http";
import { connect } from "react-redux";

const ChangePassword = (props) => {
  const [loading, setLoading] = useState(false);
  const [showErrMssg, setShowErrMssg] = useState(false);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword_1, setShowNewPassword_1] = useState(false);
  const [showNewPassword_2, setShowNewPassword_2] = useState(false);

  const [newPasswdConfirmed, setNewPasswdConfirmed] = useState(false);
  const [notify, setNotify] = useState(false);

  const [passwdValid, setPasswdValid] = useState(false);
  const [newPasswdValid, setNewPasswdValid] = useState(false);

  const [passwdFormatValid, setPasswdFormatValid] = useState(false);
  const [passwdFormatValid2, setPasswdFormatValid2] = useState(false);

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [currentPasswordErr, setCurrentPasswordErr] = useState("");
  const [newPasswordErr, setNewPasswordErr] = useState("");
  const [confirmPasswordErr, setConfirmPasswordErr] = useState("");

  const handleCurrentPasswordChange = (e) => {
    setCurrentPassword(e.target.value);
  };

  const handleNewPasswordChange = (e) => {
    const specialChar = /[^A-Za-z0-9\s]/;
    const capitalLetter = /[A-Z]/;

    setNewPassword(e.target.value);

    if (e.target.value.length >= 8) {
      setPasswdValid(true);
    } else {
      setPasswdValid(false);
    }

    if (specialChar.test(e.target.value)) {
      setPasswdFormatValid(true);
    } else {
      setPasswdFormatValid(false);
    }

    if (capitalLetter.test(e.target.value)) {
      setPasswdFormatValid2(true);
    } else {
      setPasswdFormatValid2(false);
    }
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);

    if (e.target.value.length >= 1) {
      setNewPasswdConfirmed(true);

      if (newPasswdValid) {
        setTimeout(() => setNewPasswdConfirmed(false), 5000);
      } else {
        setTimeout(() => setNewPasswdConfirmed(false), 3000);
      }
    }

    if (e.target.value === newPassword) {
      setNewPasswdValid(true);
    } else {
      setNewPasswdValid(false);
    }
  };

  const disabledBtn =
    currentPassword === "" || newPassword === "" || confirmPassword === "";

  const resetPassword = async (requestData: any) => {
    setLoading(true);
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${props.bearerToken}`,
    };
    const res = await postRequest(
      `${BASE_URL + loggedUser_baseURL}password`,
      headers,
      requestData,
    );

    if (res?.data?.responseCode === "00") {
      Alert("success", res?.data?.message);
      props.setShowModal(false);
    } else {
      Alert("error", res?.data?.message.split(":").slice(-1));
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      passwdValid &&
      passwdFormatValid &&
      passwdFormatValid2 &&
      newPasswdValid &&
      newPassword === confirmPassword
    ) {
      const reqData = {
        currentPassword: currentPassword,
        newPassword: newPassword,
      };

      return resetPassword(reqData);
    } else {
      Alert(
        "error",
        "Password Invalid, please follow the conditions displayed below.",
      );
    }

    // if (!passwdValid) {
    //     Alert('error', 'Password must be at least 8 characters long');
    // }

    // if (!passwdFormatValid) {
    //     Alert('error', 'Password must have at least 1 special character');
    // }

    // if (!passwdFormatValid2) {
    //     Alert('error', 'Password must have at least 1 Capital letter');
    // }

    if (newPassword !== confirmPassword) {
      // Alert('error', 'Password does not match');
      setNewPasswordErr("Password does not match!");
      setConfirmPasswordErr("Password does not match!");

      setShowErrMssg(true);

      setTimeout(() => setShowErrMssg(false), 5000);
    }
  };

  return (
    <AppModal
      handleClose={() => props.setShowModal(false)}
      modalStyle="max-w-sm w-full mobile:w-4/5 bg-white min-h-[300px] h-fit z-30 my-auto mx-auto left-0 right-0 animate-slide_up rounded-lg p-8 shadow-[0_8px_30px_rgb(0,0,0,0.12)] transition-all"
      contentStyle=""
      closeBtnStyle="hidden"
    >
      <form onSubmit={handleSubmit} className="flex flex-col gap-5">
        <PageTitle
          pageTitle="Update Password"
          subTitle="Change your current password here"
          subTitleStyle=""
          style="!mt-0 !gap-1"
        />

        <FormInput
          type={showCurrentPassword ? "text" : "password"}
          name="passwd"
          style="w-full"
          placeholder="********"
          inputStyle="border border-transparent text-Black2 flex-row-reverse"
          label="Current Password"
          labelStyle="font-normal text-sm leading-6 text-Black2"
          onChange={handleCurrentPasswordChange}
          value={currentPassword}
          validationErr={currentPasswordErr}
          img={showCurrentPassword ? showPwd : hidePwd}
          imgStyle="cursor-pointer w-4 h-4 block"
          imgOnClick={() => setShowCurrentPassword((prevState) => !prevState)}
        />
        <div className="flex items-start justify-between gap-5 tablet:flex-col">
          <FormInput
            type={showNewPassword_1 ? "text" : "password"}
            name="passwd"
            style="w-full"
            placeholder="********"
            inputStyle="border border-transparent text-Black2 flex-row-reverse"
            label="New Password"
            labelStyle="font-normal text-sm leading-6 text-Black2 truncate"
            onChange={handleNewPasswordChange}
            value={newPassword}
            validationErr={showErrMssg && newPasswordErr}
            img={showNewPassword_1 ? showPwd : hidePwd}
            imgStyle="cursor-pointer w-4 h-4 block"
            imgOnClick={() => setShowNewPassword_1((prevState) => !prevState)}
          />
          <FormInput
            type={showNewPassword_2 ? "text" : "password"}
            name="passwd"
            style="w-full"
            placeholder="********"
            inputStyle="border border-transparent text-Black2 flex-row-reverse"
            label="Confirm New Password"
            labelStyle="font-normal text-sm leading-6 text-Black2 truncate"
            onChange={handleConfirmPasswordChange}
            value={confirmPassword}
            validationErr={showErrMssg && confirmPasswordErr}
            img={showNewPassword_2 ? showPwd : hidePwd}
            imgStyle="cursor-pointer w-4 h-4 block"
            imgOnClick={() => setShowNewPassword_2((prevState) => !prevState)}
            indicatorStyle={`${newPasswdConfirmed && newPasswdValid ? "!border-Success bg-Success" : newPasswdConfirmed && !newPasswdValid ? "!border-PrimaryActive bg-PrimaryActive" : ""}`}
          />
        </div>

        <div className="flex flex-col gap-3">
          <span className="flex items-center justify-start gap-2 text-sm font-normal text-Black2">
            <img
              src={passwdValid ? verify_ticked : verify_unticked}
              alt="arrowLeft"
              className="w-4 h-4"
            />
            Must be at least 8 characters
          </span>
          <span className="flex items-center justify-start gap-2 text-sm font-normal text-Black2">
            <img
              src={passwdFormatValid2 ? verify_ticked : verify_unticked}
              alt="arrowLeft"
              className="w-4 h-4"
            />
            Must contain one Capital letter
          </span>
          <span className="flex items-center justify-start gap-2 text-sm font-normal text-Black2">
            <img
              src={passwdFormatValid ? verify_ticked : verify_unticked}
              alt="arrowLeft"
              className="w-4 h-4"
            />
            Must contain one special character
          </span>
          <span className="flex items-center justify-start gap-2 text-sm font-normal text-Black2">
            <img
              src={
                newPassword !== "" &&
                confirmPassword !== "" &&
                newPassword === confirmPassword
                  ? verify_ticked
                  : verify_unticked
              }
              alt="arrowLeft"
              className="w-4 h-4"
            />
            Password Match
          </span>
        </div>

        <Button
          btnType="submit"
          btnText={loading ? "Loading..." : "Reset password"}
          btnStyle={`${
            disabledBtn ? "cursor-not-allowed" : ""
          } bg-black text-white px-6 py-3 w-full`}
          disabled={disabledBtn}
        />
      </form>
    </AppModal>
  );
};

const mapStateToProps = (state: any) => ({
  bearerToken: state.auth.user_authData?.token.token,
});

export default connect(mapStateToProps)(ChangePassword);
